import React from 'react';
import { useNavigate } from 'react-router-dom';

const CardMenu = ({image, redirect, name, description}) => {

    const navigate = useNavigate();
    const redirectToPage = () => {
        navigate(redirect);
    }

    return (
        <button className='card-menu flex-grow-1' onClick={redirectToPage}>
                <h1>{name}</h1>
                <div className='btn-icon'>
                    <img src={image} alt="" className='img-icon' />
                </div>
                <ul className='card-description'>
                    {description.map((item, index) => (
                        <li key={index}>
                            {item}
                        </li>
                    ))}
                </ul>
        </button>
    );
}

export default CardMenu;
